import { FileTypeCategory, getFileCategory } from '../constants/mime-types';

export function isImageFile(mimeType: string): boolean {
  return getFileCategory(mimeType) === FileTypeCategory.IMAGE;
}

export function isPdfFile(mimeType: string): boolean {
  return getFileCategory(mimeType) === FileTypeCategory.PDF;
}

export function isVideoFile(mimeType: string): boolean {
  return getFileCategory(mimeType) === FileTypeCategory.VIDEO;
}

export function canPreview(mimeType: string): boolean {
  const category = getFileCategory(mimeType);
  return (
    category === FileTypeCategory.IMAGE ||
    category === FileTypeCategory.PDF ||
    category === FileTypeCategory.VIDEO
  );
}

/**
 * Check if a thumbnail can be generated for the given MIME type.
 *
 * Supports:
 * - Images: Native Supabase Image Transforms
 * - PDFs: Custom Edge Function rendering
 */
export function canGenerateThumbnail(mimeType: string): boolean {
  return isImageFile(mimeType) || isPdfFile(mimeType);
}

/**
 * Check if the file type supports native image transforms (Supabase Image Transforms)
 */
export function supportsNativeThumbnail(mimeType: string): boolean {
  return isImageFile(mimeType);
}

/**
 * Check if the file type requires Edge Function for thumbnail generation
 */
export function requiresEdgeFunctionThumbnail(mimeType: string): boolean {
  return isPdfFile(mimeType);
}
